(() => {
  function initialize() {
    const root = document.getElementById('IchikaCleaning');
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-cleaning-form]');
    const rows = [...root.querySelectorAll('[data-variant-row]')];
    const submit = root.querySelector('[data-submit]');
    const error = root.querySelector('[data-error]');
    const status = root.querySelector('[data-status]');
    const recovery = root.querySelector('[data-recovery]');
    const currency = root.dataset.currency || 'JPY';
    const formatter = new Intl.NumberFormat(root.dataset.locale || 'ja', {style:'currency',currency});
    let sending = false;
    let attempted = false;
    function selection() {
      let valid = true;
      let count = 0;
      let cents = 0;
      const items = [];
      rows.forEach(row => {
        const input = row.querySelector('[data-quantity]');
        const quantity = Number(input.value);
        const ok = input.disabled || (input.value !== '' && Number.isInteger(quantity) && quantity >= 0 && quantity <= 99);
        input.setAttribute('aria-invalid', String(!ok));
        valid = valid && ok;
        row.querySelector('[data-decrease]').disabled = sending || attempted || input.disabled || !ok || quantity === 0;
        row.querySelector('[data-increase]').disabled = sending || attempted || input.disabled || !ok || quantity === 99;
        if (ok && !input.disabled && quantity > 0) {
          count += quantity;
          cents += quantity * Number(row.dataset.unitPrice);
          items.push({id:row.dataset.variantId,quantity});
        }
      });
      return {valid,count,cents,items};
    }
    function update() {
      const selected = selection();
      root.querySelector('[data-count]').textContent = selected.valid ? selected.count : '—';
      root.querySelector('[data-total]').textContent = selected.valid ? formatter.format(selected.cents / 100) : '—';
      if (!attempted) {
        error.hidden = selected.valid;
        error.textContent = selected.valid ? '' : root.dataset.invalidLabel;
        submit.textContent = selected.count > 0 ? root.dataset.addLabel : root.dataset.selectLabel;
      }
      submit.disabled = sending || attempted || !selected.valid || selected.count === 0;
      return selected;
    }
    rows.forEach(row => {
      const input = row.querySelector('[data-quantity]');
      input.addEventListener('input', update);
      row.querySelector('[data-decrease]').addEventListener('click', () => {
        input.value = String(Math.max(0, Number(input.value) - 1));
        update();
      });
      row.querySelector('[data-increase]').addEventListener('click', () => {
        input.value = String(Math.min(99, Number(input.value) + 1));
        update();
      });
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (sending || attempted) return;
      const selected = update();
      if (!selected.valid || !selected.count) return;
      sending = true;
      attempted = true;
      rows.forEach(row => row.querySelector('[data-quantity]').readOnly = true);
      update();
      submit.textContent = root.dataset.busyLabel;
      form.setAttribute('aria-busy', 'true');
      error.hidden = true;
      status.hidden = true;
      let timeout;
      try {
        const controller = new AbortController();
        timeout = setTimeout(() => controller.abort(), 20000);
        const response = await fetch(root.dataset.addUrl, {
          method:'POST', credentials:'same-origin',
          headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({items:selected.items}),signal:controller.signal
        });
        const result = await response.json();
        if (!response.ok || !Array.isArray(result.items)) throw new Error('cart-add-failed');
        const complete = selected.items.every(item => result.items.some(added => String(added.variant_id || added.id) === item.id && added.quantity >= item.quantity));
        if (!complete) throw new Error('cart-add-incomplete');
        form.reset();
        status.textContent = root.dataset.readyLabel;
        status.hidden = false;
        recovery.hidden = false;
        window.location.assign(root.dataset.cartUrl);
      } catch {
        error.textContent = root.dataset.errorLabel;
        error.hidden = false;
        recovery.hidden = false;
        recovery.focus();
      } finally {
        clearTimeout(timeout);
        sending = false;
        form.setAttribute('aria-busy','false');
        submit.textContent = root.dataset.checkLabel;
      }
    });
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      form.reset();
      sending = false;
      attempted = false;
      rows.forEach(row => row.querySelector('[data-quantity]').readOnly = false);
      recovery.hidden = true;
      status.hidden = true;
      form.setAttribute('aria-busy','false');
      update();
    });
    update();
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
